import React from "react";
import "./Sakura.css";

const Sakura = () => {

    return (
        <div className="sakura">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </div>
    )
}

export default Sakura